<template>
  <v-dialog :ref="reference" v-model="visible" :max-width="maxWidth">
    <v-card :dark="dark">
      <v-card-title class="headline">{{ headline }}</v-card-title>
      <v-card-text>{{ text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secundary" flat="flat" @click.native="onClick('cancel')">{{ cancel }}</v-btn>
        <v-btn color="primary" flat="flat" @click="onClick('confirm')">{{ confirm }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

'use strict'

export default {

  name: 'VuetifyDialogConfirm',

  model: {
    prop: 'value',
    event: 'change'
  },

  props:
  {
    reference: {
      type: String,
      default: 'dialog_confirm',
      required: false
    },
    value: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: 290,
      required: false
    },
    headline: {
      type: String,
      default: 'Delete element?',
      required: false
    },
    text: {
      type: String,
      default: 'Delete element?',
      required: false
    },
    cancel: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirm: {
      type: String,
      default: 'Confirm',
      required: false
    },
    dark: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data: () => ({
    visible: false
  }),

  methods:
  {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onClick (button) {
      this.$emit('on-' + button + '-dialog', this.reference)
      this.visible = false
    }
  },

  watch: {
    value: {
      handler: function (newVal, oldVal) {
        this.visible = newVal
      },
      deep: true
    },
    visible: {
      handler: function (newVal) {
        if (newVal === false) {
          this.$emit('on-cancel-dialog', this.reference)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// src/components/vuetify-dialog-confirm.vue